export default __webpack_public_path__ + "static/top-8-places-in-the-world-to-treatyourself-self-recover-247f32b5d31b1f53f6664b8084be8ca2.jpg";